import { render, staticRenderFns } from "./BrandsSidebarLinks.vue?vue&type=template&id=bbc0c50a&scoped=true&"
import script from "./BrandsSidebarLinks.vue?vue&type=script&lang=js&"
export * from "./BrandsSidebarLinks.vue?vue&type=script&lang=js&"
import style0 from "./BrandsSidebarLinks.vue?vue&type=style&index=0&id=bbc0c50a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc0c50a",
  null
  
)

export default component.exports